import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import {  ProfileRoutes } from './profile-routing.module';
import { ProfileComponent } from './profile/profile.component';
import { EditprofileComponent } from './editprofile/editprofile.component';
import { ProfileService, PasswordService, VMuserService, ZoomService, SPSmtpService, StripePayoutsService, PanelconfigService } from './profile.service';
import { DemoMaterialModule } from '../demo-material-module';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { FlexLayoutModule } from '@angular/flex-layout';
import { SharedModule } from '../shared/shared.module';
import { RouterModule } from '@angular/router';
import { VmaccountComponent } from './vmaccount/vmaccount.component';
import { ZoommeetingComponent } from './zoommeeting/zoommeeting.component';
import { SpsmtpComponent } from './spsmtp/spsmtp.component';
import { PayoutaccountComponent } from './payoutaccount/payoutaccount.component';
import { ZapierComponent } from './zapier/zapier.component';
import { PanelConfigComponent } from './panel-config/panel-config.component';
import { ColorPickerModule } from 'ngx-color-picker';
import { PasswordchangeComponent } from './passwordchange/passwordchange.component';
import {NgxMaskModule} from 'ngx-mask';
import { BrandlistComponent } from './brandlist/brandlist.component';
import { AlertComponent } from '../shared/alert/alert.component';
import { InheritSMTPComponent } from '../shared/inherit-smtp/inherit-smtp.component';
import { CampaignregistryComponent } from './campaignregistry/campaignregistry.component';


@NgModule({
  imports: [
    CommonModule,
    DemoMaterialModule,
    FlexLayoutModule,
    FormsModule,
    ReactiveFormsModule,
    SharedModule,
    ColorPickerModule,
    NgxMaskModule.forRoot({
      showMaskTyped : true,
     
    }),
    RouterModule.forChild(ProfileRoutes)
  ],
  // entryComponents:[InheritSMTPComponent],
  declarations: [ProfileComponent, EditprofileComponent, PasswordchangeComponent, VmaccountComponent, ZoommeetingComponent, SpsmtpComponent, PayoutaccountComponent, ZapierComponent,PanelConfigComponent, BrandlistComponent,CampaignregistryComponent],
  providers: [ProfileService, PasswordService, VMuserService, ZoomService, SPSmtpService, StripePayoutsService,PanelconfigService],
  entryComponents: [AlertComponent,InheritSMTPComponent,CampaignregistryComponent],

})
export class ProfileModule { }
